import { useEffect } from 'react';
import { useQuery, useMutation } from '@tanstack/react-query';
import { notificationApi } from '@/api/notificationApi';
import { useNotificationStore } from '@/store/notificationStore';
import { useAuthStore } from '@/store/authStore';
import { getSocket } from '@/lib/socket';
import type { Notification } from '@/types/chat/chat.types';
import { QK } from './queryKeys';



/** Lấy danh sách thông báo */
export function useNotifications() {
  const setNotifications = useNotificationStore((s) => s.setNotifications);
  const isAuthenticated = useAuthStore((s) => s.isAuthenticated);

  const query = useQuery({
    queryKey: QK.NOTIFICATIONS,
    queryFn: notificationApi.getMyNotifications,
    enabled: isAuthenticated,
    staleTime: 1000 * 60,
    retry: false,
  });

  useEffect(() => {
    if (query.data && Array.isArray(query.data)) {
      setNotifications(query.data);
    }
  }, [query.data, setNotifications]);

  return query;
}

/** Đánh dấu đã đọc */
export function useMarkRead() {
  const markAsRead = useNotificationStore((s) => s.markAsRead);

  return useMutation({
    mutationFn: notificationApi.markRead,
    onSuccess: (_, notificationId) => {
      markAsRead(notificationId);
    },
  });
}

/** Lắng nghe thông báo real-time */
export function useNotificationSocket() {
  const addNotification = useNotificationStore((s) => s.addNotification);

  useEffect(() => {
    try {
      const socket = getSocket();

      // BUG FIX: Bỏ check `if (!socket.connected) return`
      // Vì socket.on() đăng ký listener trên socket object,
      // listener sẽ tự fire khi có event dù socket connect sau.
      const handler = (noti: Notification) => {
        addNotification(noti);
      };

      socket.on('receiveNotification', handler);
      return () => {
        socket.off('receiveNotification', handler);
      };
    } catch {
      // Socket not available, ignore
    }
  }, [addNotification]);
}
